export default __webpack_public_path__ + "static/media/wave.198369bc.svg";